export default "__VITE_ASSET__Bj1ImebM__"